{
  "name": "365Portal",
  "version": "9.0.0",
  "engines": {
    "node": ">=20.11.21"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve --ssl --no-hmr",
    "_serve": "ng serve --ssl --no-hmr",
    "build": "ng build",
    "watch": "ng serve --configuration development --ssl",
    "serve:forsyning": "ng serve --configuration forsyning-dev --ssl",
    "serve:libra": "ng serve --configuration libra-dev --ssl",
    "build:libra:prod": "ng build --configuration libra-prod",
    "build:libra:dev": "ng build --configuration libra-dev",
    "build:forsyning:prod": "ng build --configuration forsyning-prod",
    "build:forsyning:dev": "ng build --configuration forsyning-dev",
    "!": "npx ng serve",
    "!b": "npx ng build",
    "!bp": "npx ng build --configuration production",
    "lint": "ng lint",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:coverage": "jest --coverage",
    "version:test": "npm version premajor --preid=test --no-git-tag-version",
    "version:release": "npm version major --no-git-tag-version",
    "version:tag": "git tag v\"$npm_package_version\"-web && git push origin tag v\"$npm_package_version\"-web",
    "lib:build": "cd projects/portal-lib/ && npm run build",
    "lib:deps:sync": "node scripts/sync-portal-lib-deps.cjs",
    "lib:build:prod": "cd projects/portal-lib/ && npm run build:prod",
    "lib:build:watch": "cd projects/portal-lib/ && npm run build:watch",
    "lib:publish": "npm publish ./dist/portal-lib",
    "lib:publish:beta": "cd projects/portal-lib/ && npm run publish:beta",
    "lib:version:patch": "cd projects/portal-lib/ && npm run version:patch",
    "lib:version:minor": "cd projects/portal-lib/ && npm run version:minor",
    "lib:version:major": "cd projects/portal-lib/ && npm run version:major",
    "lib:version:tag": "cd projects/portal-lib/ && npm run version:tag",
    "lib:ci:publish": "cd projects/portal-lib/ && npm run ci:publish"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.17",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.17",
    "@angular/compiler": "^21.2.17",
    "@angular/core": "^21.2.17",
    "@angular/forms": "^21.2.17",
    "@angular/platform-browser": "^21.2.17",
    "@angular/platform-browser-dynamic": "^21.2.17",
    "@angular/router": "^21.2.17",
    "@cloud-and-service/portal-lib": "^0.27.28",
    "@ngxs/storage-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@swimlane/ngx-charts": "^24.0.0",
    "angular-user-idle": "^4.0.0",
    "barcode-detector": "^3.2.0",
    "bootstrap": "^5.3.8",
    "clone-deep": "^4.0.1",
    "guid-typescript": "^1.0.9",
    "lodash": "^4.18.1",
    "moment": "^2.30.1",
    "ng-http-loader": "^20.0.0",
    "ngx-bootstrap": "^21.2.0",
    "ngx-toastr": "^20.0.5",
    "rxjs": "^7.8.2",
    "signature_pad": "^5.1.3",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.4.0",
    "@angular-eslint/eslint-plugin": "^21.2.0",
    "@angular-eslint/eslint-plugin-template": "^21.2.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.16",
    "@angular/cli": "^21.2.16",
    "@angular/compiler-cli": "^21.2.17",
    "@ngxs/devtools-plugin": "^21.0.0",
    "@types/d3": "^7.4.3",
    "@types/jest": "^30.0.0",
    "@types/lodash": "^4.17.24",
    "@types/node": "^25.9.4",
    "@typescript-eslint/eslint-plugin": "^8.61.1",
    "@typescript-eslint/parser": "^8.61.1",
    "concurrently": "^10.0.3",
    "eslint": "^10.5.0",
    "eslint-plugin-unused-imports": "^4.4.1",
    "jest": "^30.4.2",
    "jest-environment-jsdom": "^30.4.1",
    "jest-preset-angular": "^16.2.0",
    "ng-packagr": "^21.2.5",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3"
  }
}
